import { cn } from "@repo/shared/utils";
import { Button } from "./Button";
import { Label } from "./Label";

export interface CheckButtonRowProps {
  id: string;
  label?: string;
  className?: string;
  buttonClassName?: string;
  buttonLabels: string[];
  disabled?: boolean;
  value: boolean[];
  onChange?: (value: boolean[]) => void;
  allToggler?: boolean;
  invToggler?: boolean;
}

export const CheckButtonRow = ({
  id,
  label,
  className,
  buttonClassName,
  buttonLabels,
  disabled,
  value,
  onChange,
  allToggler = true,
  invToggler = true,
}: CheckButtonRowProps) => {
  const normalize = (value: boolean[]) => {
    const out = [];
    for (let i = 0; i < buttonLabels.length; i++) {
      out.push(!!value[i]);
    }
    return out;
  };
  const handleButton = (index: number) => {
    value = normalize(value);
    value[index] = !value[index];
    onChange?.(value);
  };
  const handleAll = () => {
    value = normalize(value);
    if (value.includes(false)) {
      value = buttonLabels.map(() => true);
    } else {
      value = buttonLabels.map(() => false);
    }
    onChange?.(value);
  };
  const handleInvert = () => {
    value = normalize(value);
    value = value.map((v) => !v);
    onChange?.(value);
  };

  return (
    <>
      {label && <Label label={label} id={id} />}
      <div
        className={cn("flex flex-row gap-x-1 mt-1.5 items-center", className)}
      >
        {buttonLabels.map((label, i) => (
          <Button
            key={i}
            type="button"
            disabled={disabled}
            className={cn(
              "rounded-full",
              value[i] || "bg-slate-300",
              buttonClassName
            )}
            onClick={handleButton.bind(null, i)}
          >
            {label}
          </Button>
        ))}
        <div className="ml-2 flex flex-row gap-x-1">
          {allToggler && (
            <Button
              type="button"
              disabled={disabled}
              variant="tertiary"
              className={cn(
                "rounded-full px-2 h-8 text-[12px]",
                buttonClassName
              )}
              onClick={handleAll}
            >
              ALL
            </Button>
          )}
          {invToggler && (
            <Button
              type="button"
              disabled={disabled}
              variant="secondary"
              className={cn(
                "rounded-full px-2 h-8 text-[12px]",
                buttonClassName
              )}
              onClick={handleInvert}
            >
              INV
            </Button>
          )}
        </div>
      </div>
    </>
  );
};
